import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import {Loader2, ShieldX} from 'lucide-react'

interface ProtectedRouteProps {
  children: React.ReactNode
  /** 'any' = qualquer utilizador autenticado; 'admin' = apenas administradores */
  require?: 'any' | 'admin'
}

export default function ProtectedRoute({ children, require = 'any' }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, isAdmin, user } = useAuth()

  // Aguarda a verificação inicial do estado de autenticação
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="flex flex-col items-center gap-3 text-gray-400">
          <Loader2 size={28} className="animate-spin text-red-600" />
          <span className="text-sm">A verificar sessão...</span>
        </div>
      </div>
    )
  }

  // Não autenticado → redireciona para login
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />
  }

  if (user?.isBlocked && !isAdmin) {
    return null
  }

  // Autenticado mas sem permissão de admin
  if (require === 'admin' && !isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] p-8">
        <div className="text-center max-w-sm">
          <div className="w-14 h-14 bg-red-50 dark:bg-red-950 rounded-full flex items-center justify-center mx-auto mb-4">
            <ShieldX size={24} className="text-red-600" />
          </div>
          <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
            Acesso Negado
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Você não tem permissão para aceder esta área. É necessário nível de Administrador.
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
